<style lang="scss" src='./WeatherWidget.scss' scoped></style>
<template src="./WeatherWidget.html"></template>

<script>
import moment from 'moment';
import { required } from 'vee-validate/dist/rules';
import LocalWeatherDetails from '../../views/localWeather/LocalWeatherDetails'

export default {
  name: 'WeatherWidget',
  components: {
    LocalWeatherDetails
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    weather: {
      required: false,
    },
    loading: {
      required: false,
    },
    precipitation_totals: {
      required: false,
    },
    station_id:{
      required: false
    },
    showDailyTemps: {
      required: false,
    },
    dailyTemps: {
      type: Object,
      required: false,
    },
  },
  data() {
    return ({
    });
  },
  computed: {
    sunrise: function () {
      return this.getSunriseOrSet('sunrise');
    },
    sunset: function () {
      return this.getSunriseOrSet('sunset');
    },
    forecasts: function () {
       if (this.weather && this.weather.daily && this.weather.daily.length) {
         const lastIndex = this.weather.daily.length > 6 ? 6 : this.weather.daily.length;
         return this.weather.daily.slice(1, lastIndex);
       }
      return null;
    },
  },

  methods: {
    getSunriseOrSet(sunRiseSet) {
      if (this.weather && this.weather.current && this.weather.current[sunRiseSet]) {
         return this.G_formatDate({date: this.weather.current[sunRiseSet] * 1000, pretty: false, noHour: false, justHour: true});
      }
      return '';
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
  },
};
</script>
